export class UserInfo {
  public id: number;
  public lastName: string;
  public firstName: string;
  public patronymic: string;
  public login: string;
  public address: string;
  public email: string;
  public collegeId: number;
  public positionId: number;
  public iin: string;
  public phoneNumber: string;
  public workPhoneNumber: string;
  public sexId: number;
  public birthday: string;
  public positionTypeId: number;
  public blocked = false;
  public block: string;
  public room: string;
  public organizationId: number;
  public roleIds: number[];
  public checked: boolean;
  public profilePhotoId: string;
  public profilePhoto: string;
}

export class UserConstants {

  public static userConst: any = {
    positionType: {
      COLLEGE: 1,
      ORGANIZATION: 2
    },
  };

  public static permission: any = {
    accessType: {
      READ: 1,
      WRITE: 2
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/user-information/users-info.ts